import {
    formsGalleryUrl,
    loginUrl,
    oldBrowserUrl,
    phoneVerificationUrl,
    signupUrl,
    usersDirectoryUrl,
} from 'mk2/apps/users/urls';
import { Route } from 'mk2/containers/Application/Application';

export const routes: Route[] = [ {
    app: 'users',
    exact: true,
    path: phoneVerificationUrl,
    getPage: () => {
        return import('mk2/apps/users/containers/PhoneVerification/PhoneVerificationPage' /* webpackChunkName: "users.PhoneVerification" */);
    },
    modules: [ 'mk2/apps/users/containers/PhoneVerification/PhoneVerificationPage' ],
}, {
    app: 'users',
    exact: true,
    path: usersDirectoryUrl,
    getPage: () => {
        return import('mk2/apps/users/containers/UsersDirectory/UsersDirectoryPage' /* webpackChunkName: "users.UsersDirectory" */);
    },
    modules: [ 'mk2/apps/users/containers/UsersDirectory/UsersDirectoryPage' ],
}, {
    app: 'users',
    exact: true,
    path: signupUrl,
    getPage: () => {
        return import('mk2/apps/users/containers/Signup/SignupPage' /* webpackChunkName: "users.Signup" */);
    },
    modules: [ 'mk2/apps/users/containers/Signup/SignupPage' ],
}, {
    app: 'users',
    exact: true,
    path: loginUrl,
    getPage: () => {
        return import('mk2/apps/users/containers/Login/LoginPage' /* webpackChunkName: "users.Login" */);
    },
    modules: [ 'mk2/apps/users/containers/Login/LoginPage' ],
}, {
    app: 'users',
    exact: true,
    path: oldBrowserUrl,
    getPage: () => {
        return import('mk2/apps/users/containers/OldBrowser/OldBrowserPage' /* webpackChunkName: "users.OldBrowser" */);
    },
    modules: [ 'mk2/apps/users/containers/OldBrowser/OldBrowserPage' ],
}, {
    app: 'users',
    exact: true,
    path: formsGalleryUrl,
    getPage: () => {
        return import('mk2/apps/users/containers/FormsGallery/FormsGalleryPage' /* webpackChunkName: "users.FormsGallery" */);
    },
    modules: [ 'mk2/apps/users/containers/FormsGallery/FormsGalleryPage' ],
}];
